<template>
  <div v-if="course" class="space-y-6 px-3 md:px-0">

    <div class="border-b border-gray-200 pb-4">
      <h1 class="text-lg font-bold">Desempeño del curso: {{ course.title }}</h1>
      <p class="text-sm text-gray-500">Resumen de tu actividad y progreso en este tema específico.</p>
    </div>

    <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
      <CourseAccuracy :course-id="course.id" :is-premium="isPremiumUser" />
      <CourseTotalAttemptsKpi :course-id="course.id" :is-premium="isPremiumUser" />
      <CourseStreakKpi :course-id="course.id" :is-premium="isPremiumUser" />
    </div>

    <div class="grid grid-cols-1">
      <ModuleEvolutionKpi :course-id="course.id" :is-premium="isPremiumUser" />
    </div>

    <WorstAndBest :course-id="course.id" :is-premium="isPremiumUser" />

    <MobPaymentModal ref="mobPaymentModal" :prevent-close="true" :hide-header-close="true" :show-later-button="true" />
  </div>
</template>

<script>
import CourseAccuracy from './components/CoursePerformance/CourseAccuracy.vue';
import CourseTotalAttemptsKpi from './components/CoursePerformance/CourseTotalAttempstsKpi.vue';
import CourseStreakKpi from './components/CoursePerformance/CourseStreakKpi.vue';
import ModuleEvolutionKpi from './components/CoursePerformance/ModuleEvolutionKpi.vue';
import WorstAndBest from './components/CoursePerformance/WorstAndBest.vue';
import MobPaymentModal from '../payment-premium/PaymentModal.vue';

export default {
  name: "CoursePerformance",

  components: {
    CourseAccuracy,
    CourseTotalAttemptsKpi,
    CourseStreakKpi,
    ModuleEvolutionKpi,
    WorstAndBest,
    MobPaymentModal
  },

  computed: {
    course() {
      return this.$store.state.course.current;
    },
    isPremiumUser() {
      return this.$store.state.auth.isPremium;
    },
  },

  async created() {
    // Si isPremium es null, obtener el estado premium del servidor
    if (this.isPremiumUser === null) {
      await this.$store.dispatch("auth/fetchPremiumStatus");
    }
  },

  mounted() {
    // Verificar después de que el estado premium se haya cargado
    this.checkPremiumStatus();
  },

  watch: {
    isPremiumUser(newValue) {
      // Cuando el estado premium cambia, verificar si mostrar el modal
      if (newValue !== null) {
        this.checkPremiumStatus();
      }
    }
  },

  methods: {
    checkPremiumStatus() {
      // Solo mostrar el modal si isPremium es explícitamente false (no null)
      if (this.isPremiumUser === false) {
        this.$refs["mobPaymentModal"].showModalPayment();
      }
    },
  },
};
</script>